export const defaultUserMessageStyles = {
  fontSize: "14px"
};